<div class="d-flex h-100 py-2 points-balance">
  <span class="icons material-icons text-white"> loyalty </span>
  <span class="fw-bold text-white">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
</div>
